import { httpService } from '@/api/v1/http.service'
import useDownload, { type DownloadParams } from '@/hooks/useDownload'
import { parseColumnsToFetchKeys } from '@/utils/parse-columns-to-fetch-keys'

import { type StudentClassesParams } from '../queries/useStudentClasses'

type Params = DownloadParams & StudentClassesParams

const useClassesDownload = (classesDownloadParams: Params) =>
  useDownload({
    fileName: 'classes',
    requestParams: classesDownloadParams,
    // @ts-expect-error Waits for backend fix - file type should be returned
    downloadMutation: (params: Params) =>
      httpService.panel.panelClassesList(
        {
          id: params.id,
          student_id: params.studentId,
          tutor_id: params.tutorId,
          academic_level_id: params.academicLevelId,
          format: params.format,
          fetchKeys: parseColumnsToFetchKeys(params.columnsKey, params.format)
        },
        { format: 'blob' }
      )
  })

export default useClassesDownload
